import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as BackIcon } from "../../../../assets/svg/icons/back.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";

interface InfoMoveBatchProps {
  task: ITaskMoveBatch | undefined;
}

export default function InfoMoveBatch({ task: taskMoveBatch }: InfoMoveBatchProps) {
  useTranslation();
  const isMerge = taskMoveBatch?.task_type === "Junção de lotes";
  const isSameBatch = Boolean(taskMoveBatch?.batch_initials)
    && taskMoveBatch?.batch_initials === taskMoveBatch?.batch_target_initials;
  const displayValue = (value: string | undefined) => isMerge ? value || "—" : value;

  const targetBatch = (
    <div>
      <span><Trans i18nKey={isMerge ? "taskDetails.mergeBatches.incorporatedBatch" : "taskDetails.toBatch"} /></span>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <AnimalsIcon width={30} className="iconInitialTaskInfo" />
        <div className="labelInitialTaskInfo">
          <span>{displayValue(taskMoveBatch?.batch_target_initials)}</span>
          <PointIcon width={15} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div >
        <span><Trans i18nKey={isMerge ? "taskDetails.mergeBatches.retainedBatch" : "taskDetails.fromBatch"} /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{displayValue(taskMoveBatch?.batch_initials)}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      {isMerge && targetBatch}

      <div >
        <span><Trans i18nKey={isMerge ? "taskDetails.mergeBatches.fromPaddock" : "taskDetails.onPaddock"} /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span>{displayValue(taskMoveBatch?.source_micro_area_full_initials)}</span>
          <div className="labelInitialTaskInfo">
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <BackIcon width={30} style={{ transform: "rotate(270deg)" }} />
        <GrassIcon width={30} />
      </div>

      {!isMerge && !isSameBatch && targetBatch}

      <div >
        <span><Trans i18nKey={isMerge ? "taskDetails.mergeBatches.toPaddock" : "taskDetails.onPaddock"} /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span>{displayValue(taskMoveBatch?.destination_micro_area_full_initials)}</span>
          <div className="labelInitialTaskInfo">
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      {taskMoveBatch?.categories?.map((category, index) => (
        <div key={index}>
          <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(category.category_description.name, category.category_description.age_description)}</div>
          <div className="lot__subtitle--category">{translateAnimalCategoryAge(category.category_description.age_description, category.category_description.name)}</div>
          <CounterInputV2 name={`info-move-batch-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
        </div>
      ))}
    </>
  )
}
